import { Add } from "shared/components/Add"
import automatizationImg from '../images/automatization.png'
import { AppRoute } from "../constants"

export const ExpertAutomatizationAdd = ({ }) => {
    const renderText = () => {
        return <div style={{
            fontSize: 'calc(var(--font-size) * 1.8 )'
        }}>
            Нужна продвинутая <span className="text-accent">автоматизация</span> технологических процессов <span className="text-accent">экспертного</span> уровня?
        </div>
    }
    const renderBtn = () => {
        return <a
            href={AppRoute.ProductComparison}
            style={{
                fontSize: 'calc(var(--font-size) * 1.3 )'
            }}
            className="btn btn-danger">
            Посмотреть
        </a>
    }
    return <Add
        text={renderText()}
        description={renderBtn()}
        image={automatizationImg}
    />
}